import BaseModelAPI from '../BaseModelAPI';

export default class Gender extends BaseModelAPI {
	static entity = 'gender';
	static entityName = 'gender';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}